import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import React, { Component } from "react";

class LightBox extends Component {
  render() {
    const { isOpen, images, closeLightBox } = this.props;
    return (
      <React.Fragment>
        {isOpen && (
          <Lightbox mainSrc={images} onCloseRequest={() => closeLightBox()} />
        )}
      </React.Fragment>
    );
  }
}

export default LightBox;



// WEBPACK FOOTER //
// ./src/components/Common/lightbox.jsx